import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { Config } from "../../core/DefaultConfig";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { DeleteModel } from "../../core/models/dele.model";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { DeleteDialogComponent } from "../../shared/delete-dialog/delete-dialog.component";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { AddEditMouzaComponent } from "./add-edit-dialog-mouza/add-edit-mouza.component";
import { Mouza } from "../../core/models/mouza.model";
import { ApplicationDataService } from "../../core/services/application-data.service";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";
import { AppUrlConstants } from "../../core/constants/AppUrlConstants";
import { GenericCrudService } from "../../core/services/generic-crud.service";
import { SegmentPipe } from "../../core/pipes/segment.pipe";
import { MatMenuModule } from '@angular/material/menu';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: "app-mouza",
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    TranslateModule,
    SegmentPipe,
    MatMenuModule,
  ],
  templateUrl: "./mouza.component.html",
  styleUrls: ["./mouza.component.css"],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Mouzas per page') }
  ],
})
export class MouzaComponent implements AfterViewInit {
  displayedColumns: string[] = [
    "sr",
    "division",
    "district",
    "tehsil",
    "name",
    "description",
    "action",
  ];
  divisionList: any[] = [];
  districtList: any[] = [];
  tehsilList: any[] = [];
  filteredListDivision: any[] = [];
  filteredListDistrict: any[] = [];
  filteredListTehsil: any[] = [];
  config = new Config();
  dataSource: MatTableDataSource<Mouza>;
  dataList: Mouza[] = [];
  segmentPipe = new SegmentPipe();
  deleteModel: DeleteModel = {
    title: "DROP_MOUZA_TITLE",
    message: "DROP_MOUZA_MESSAGE",
    deleteButtonText: "DROP",
    cancelButtonText: "CALCEL",
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    private crudService: GenericCrudService,
    private appDataService: ApplicationDataService
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngAfterViewInit(): void {
    this.getList();
    this.getDivisionList();
    this.getDistrictList();
    this.getTehsilList();
  }

  // Check if export should be disabled
  get isExportDisabled(): boolean {
    return !this.dataSource.filteredData || this.dataSource.filteredData.length === 0;
  }

  getList() {
    this.appDataService.getByType("MOUZA").subscribe({
      next: (res: any) => {
        this.dataList = res.data;
        this.dataSource = new MatTableDataSource(this.dataList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      },
    });
  }

  getDivisionList() {
    this.appDataService.getByType("DIVISION").subscribe({
      next: (res: any) => {
        this.divisionList = res.data;
        this.filteredListDivision = this.onFilteredListSearch(
          null,
          this.divisionList,
          "name"
        );
      },
    });
  }

  getDistrictList() {
    this.appDataService.getByType("DISTRICT").subscribe({
      next: (res: any) => {
        this.districtList = res.data;
        this.filteredListDistrict = this.onFilteredListSearch(
          null,
          this.districtList,
          "name"
        );
      },
    });
  }

  getTehsilList() {
    this.appDataService.getByType("TEHSIL").subscribe({
      next: (res: any) => {
        this.tehsilList = res.data;
        this.filteredListTehsil = this.onFilteredListSearch(
          null,
          this.tehsilList,
          "name"
        );
      },
    });
  }

  getDistrictId(mouza: Mouza): number | null {
    const tehsil = this.tehsilList.find(t => t.adminStrId === mouza.parentAdminStrId);
    return tehsil ? tehsil.parentAdminStrId : null;
  }

  getDivisionId(mouza: Mouza): number {
    const districtId = this.getDistrictId(mouza);
    if (districtId !== null) {
      const district = this.districtList.find(d => d.adminStrId === districtId);
      return district ? district.parentAdminStrId : 0;
    }
    return 0;
  }

  // Helper method to get district name from a mouza
  getDistrictName(mouza: Mouza): string {
    const tehsil = this.tehsilList.find(t => t.adminStrId === mouza.parentAdminStrId);

    if (tehsil) {
      return this.segmentPipe.transform(tehsil.parentAdminStrId, this.districtList) || '';
    }

    return '';
  }

  // Helper method to get division name from a mouza
  getDivisionName(mouza: Mouza): string {
    const tehsil = this.tehsilList.find(t => t.adminStrId === mouza.parentAdminStrId);

    if (tehsil) {
      const district = this.districtList.find(d => d.adminStrId === tehsil.parentAdminStrId);

      if (district) {
        return this.segmentPipe.transform(district.parentAdminStrId, this.divisionList) || '';
      }
    }

    return '';
  }

  // Helper method to get properly sorted data
  private getSortedData(data: Mouza[]): Mouza[] {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.slice().sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      const valueA = this.getSortValue(a, this.sort.active);
      const valueB = this.getSortValue(b, this.sort.active);

      return this.compare(valueA, valueB, isAsc);
    });
  }

  // Helper method to get sort value from object
  private getSortValue(item: Mouza, column: string): string | number {
    switch (column) {
      case 'division':
        return (this.getDivisionName(item) || '').toLowerCase();
      case 'district':
        return (this.getDistrictName(item) || '').toLowerCase();
      case 'tehsil':
        return (this.segmentPipe.transform(item.parentAdminStrId, this.tehsilList) || '').toLowerCase();
      case 'name':
        return (item.name || '').toLowerCase();
      case 'description':
        return (item.description || '').toLowerCase();
      case 'segmentType':
        return (item.segmentType || '').toLowerCase();
      default:
        return '';
    }
  }

  // Helper method to compare values
  private compare(a: string | number, b: string | number, isAsc: boolean): number {
    if (a < b) {
      return isAsc ? -1 : 1;
    }
    if (a > b) {
      return isAsc ? 1 : -1;
    }
    return 0;
  }

  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: "OK",
        },
      },
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onFilteredListSearch(
    event: any,
    originalList: any[],
    property: string
  ): any[] {
    let filteredList: any[];
    if (event && event.target.value) {
      filteredList = originalList.filter((item) =>
        item[property].toLowerCase().includes(event.target.value.toLowerCase())
      );
    } else {
      filteredList = originalList;
    }
    return filteredList;
  }

  add() {
    const dialogRef = this.dialog.open(AddEditMouzaComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  edit(updateRecord: Mouza, rowNumber: number) {
    const dialogRef = this.dialog.open(AddEditMouzaComponent, {
      data: updateRecord,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }
  delete(rowNumber: number) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService
          .delete(rowNumber, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL)
          .subscribe({
            next: (res: any) => {
              this.getList();
            },
            error: (e) => {
              if (e?.status == 409) {
                if (e?.error?.errors !== null) {
                  for (const property in e.error.errors) {
                    this.openAlert(e.error.errors[property]);
                  }
                } else {
                  this.openAlert(e?.error?.message);
                }
              }
            },
          });
      }
    });
  }

  /**
   * Export current or all mouzas to PDF with proper Urdu support
   */
  async downloadAllAsPdf(scope: "all" | "current"): Promise<void> {
    // Check if export should be disabled
    if (this.isExportDisabled) {
      this.openAlert("No data available to export");
      return;
    }

    // Determine which data set to use
    let list: Mouza[];
    if (scope === "all") {
      // Get properly sorted and filtered data
      list = this.getSortedData(this.dataSource.filteredData);
    } else {
      // Get only the current page data (sorted and filtered)
      const sortedData = this.getSortedData(this.dataSource.filteredData);
      const start = this.paginator.pageIndex * this.paginator.pageSize;
      const end = start + this.paginator.pageSize;
      list = sortedData.slice(start, end);
    }

    // Create a printable HTML document with proper RTL support
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      this.openAlert('Please allow pop-ups to generate the PDF');
      return;
    }

    // Write the HTML content with proper RTL support
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Mouza List</title>
        <meta charset="UTF-8">
        <style>
          @import url('https://fonts.googleapis.com/earlyaccess/notonastaliqurdu.css');
          
          @page {
            size: landscape;
          }

          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          
          h1 {
            text-align: center;
            margin-bottom: 30px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          
          td {
            border: 1px solid #ddd;
            padding: 8px;
            font-size: 14px;
            text-align: center;
          }
          
          th {
            background-color: #00a65a;
            color: white;
            border: 1px solid #ddd;
            padding: 8px;
            text-align: center;
            font-weight: bold;
            font-size: 16px;
          }
          
          .urdu-text {
            font-family: 'Noto Nastaliq Urdu', serif;
            direction: rtl;
            text-align: right;
          }
          
          .center-text {
            text-align: center;
          }

          .logo-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 20px;
          }
          .logo-container img {
            margin-right: 15px;
          }
          .logo-container img:first-child {
            height: 80px;
            width: auto;
          }
          .logo-container img:last-child {
            height: 50px;
            width: auto;
          } 

          @media print {
            button {
              display: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="logo-container">
          <img src="../../../assets/img/logo.png" alt="Logo">
          <img src="../../../assets/img/pulselogo.png" alt="Pulse Logo">
        </div>
        <h1>Mouza List</h1>
        <table>
          <thead>
            <tr>
              <th class="center-text">Sr. No/<span class="urdu-text">سیریل نمبر</span></th>
              <th>Division/<span class="urdu-text">ڈویژن</span></th>
              <th>District/<span class="urdu-text">ضلع</span></th>
              <th>Tehsil/<span class="urdu-text">تحصیل</span></th>
              <th>Mouza Name/<span class="urdu-text">موضع کا نام</span></th>
              <th>Description/<span class="urdu-text">تفصیل</span></th>
              <th class="center-text">Segment Type/<span class="urdu-text">سیگمنٹ کی قسم</span></th>
            </tr>
          </thead>
          <tbody>
            ${list.map((item, index) => `
              <tr>
                <td class="center-text">${index + 1}</td>
                <td><span class="urdu-text">${this.getDivisionName(item) || ''}</span></td>
                <td><span class="urdu-text">${this.getDistrictName(item) || ''}</span></td>
                <td><span class="urdu-text">
                  ${this.segmentPipe.transform(item.parentAdminStrId, this.tehsilList) || ''}
                </span></td>
                <td><span class="urdu-text">${item.name || ''}</span></td>
                <td><span class="urdu-text">${item.description || ''}</span></td>
                <td class="center-text">${item.segmentType || ''}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <script>
          // Auto-print when fonts are loaded
          document.fonts.ready.then(() => {
            // Short delay to ensure rendering is complete
            setTimeout(() => {
              window.print();
            }, 1000);
          });
        </script>
      </body>
      </html>
    `);

    printWindow.document.close();
  }

  /**
   * Export current or all mouzas to CSV with proper Urdu encoding
   */
  downloadAllAsExcel(scope: "all" | "current"): void {
    // Check if export should be disabled
    if (this.isExportDisabled) {
      this.openAlert("No data available to export");
      return;
    }

    let list: Mouza[];
    if (scope === "all") {
      // Get properly sorted and filtered data
      list = this.getSortedData(this.dataSource.filteredData);
    } else {
      // Get only the current page data (sorted and filtered)
      const sortedData = this.getSortedData(this.dataSource.filteredData);
      const start = this.paginator.pageIndex * this.paginator.pageSize;
      const end = start + this.paginator.pageSize;
      list = sortedData.slice(start, end);
    }

    // Add BOM (Byte Order Mark) for UTF-8 encoding to ensure proper Urdu display
    const BOM = '\uFEFF';

    const headers = [
      "Sr. No",
      "Division",
      "District",
      "Tehsil",
      "Mouza Name",
      "Description",
      "Segment Type"
    ];

    const rows = list.map((d, i) => [
      i + 1,
      `"${(this.getDivisionName(d) || '').replace(/"/g, '""')}"`,
      `"${(this.getDistrictName(d) || '').replace(/"/g, '""')}"`,
      `"${(this.segmentPipe.transform(d.parentAdminStrId, this.tehsilList) || '').replace(/"/g, '""')}"`,
      `"${(d.name || '').replace(/"/g, '""')}"`,
      `"${(d.description || '').replace(/"/g, '""')}"`,
      `"${(d.segmentType || '').replace(/"/g, '""')}"`
    ]);

    // Add BOM to ensure proper UTF-8 encoding for Urdu characters
    const csvContent = BOM + [headers.join(","), ...rows.map((r) => r.join(","))].join("\r\n");

    // Set explicit UTF-8 encoding in the blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `mouza-${scope}.csv`);
    link.click();
  }
}
